import { render, staticRenderFns } from "./vLiveCard.vue?vue&type=template&id=7cf561cc&scoped=true"
import script from "./vLiveCard.vue?vue&type=script&lang=js"
export * from "./vLiveCard.vue?vue&type=script&lang=js"
import style0 from "./vLiveCard.vue?vue&type=style&index=0&id=7cf561cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf561cc",
  null
  
)

export default component.exports